var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[(_vm.hasSelectedBrand || _vm.id)?_c('Brand'):_c('Brands')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }